"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../../schema");
const surgicalProcedureName = schema_1.Schema.string().optional().maxLength(100);
const dateOfSurgicalProcedure = schema_1.Schema.string().optional().date();
const surgicalProcedureType = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ surgicalProcedureName, dateOfSurgicalProcedure }))
    .interpretation({ vocab: "ltx", code: "surgical_procedure_type" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ surgicalProcedureType })
    .interpretation({ vocab: "ltx", code: "surgical_procedures" });
